module.exports = __webpack_public_path__ + "img/6.04f29b95.png";